'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

const ZuluLogo = () => (
  <svg 
    className="w-[120px] h-14" 
    viewBox="0 0 120 56" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      d="M28.7081 45.9981C29.0032 45.9981 29.2416 46.1006 29.4232 46.3058C29.6275 46.5109 29.7296 46.7617 29.7296 47.058V51.7423C29.7296 52.0615 29.6388 52.3236 29.4572 52.5288C29.2756 52.7111 29.0259 52.8023 28.7081 52.8023H6.84911C6.48592 52.8023 6.15679 52.6883 5.86171 52.4604C5.58932 52.2324 5.45312 51.9361 5.45312 51.5714V48.7334C5.45312 48.4143 5.47582 48.1522 5.52122 47.947C5.58932 47.7419 5.72551 47.5025 5.9298 47.229L19.1065 30.0304H7.32578C7.0307 30.0304 6.78101 29.9278 6.57672 29.7226C6.37243 29.4947 6.27029 29.2439 6.27029 28.9704V24.2519C6.27029 23.9556 6.36108 23.7162 6.54267 23.5339C6.74696 23.3287 7.008 23.2261 7.32578 23.2261H28.1974C28.5152 23.2261 28.7535 23.3287 28.9124 23.5339C29.094 23.7162 29.1508 23.967 29.0827 24.2861L29.1167 27.7737C29.094 27.9104 29.0373 28.07 28.9465 28.2524C28.9465 28.3207 28.8897 28.4347 28.7762 28.5943L15.7698 45.9981H28.7081Z" 
      fill="currentColor"
    />
    <path 
      d="M62.1777 23.1919C62.8132 23.1919 63.131 23.5225 63.131 24.1835V51.9133C63.131 52.2096 63.0402 52.449 62.8586 52.6313C62.6997 52.7909 62.4614 52.8707 62.1436 52.8707H57.7854C57.2634 52.8707 56.9569 52.6541 56.8661 52.221L56.2873 49.1779C55.1978 50.614 53.8358 51.7423 52.2015 52.563C50.5899 53.3836 48.8534 53.7939 46.9921 53.7939C44.5633 53.7939 42.4523 53.2468 40.6591 52.1526C38.8659 51.0585 37.4926 49.4971 36.5393 47.4683C35.5859 45.4396 35.1092 43.0575 35.1092 40.3222V24.2177C35.1092 23.8986 35.2 23.6592 35.3816 23.4997C35.5632 23.3173 35.8016 23.2261 36.0966 23.2261H41.5444C41.8622 23.2261 42.1005 23.3173 42.2594 23.4997C42.441 23.6592 42.5318 23.8986 42.5318 24.2177V40.3906C42.5318 41.5531 42.8155 42.613 43.383 43.5704C43.9732 44.5278 44.7563 45.2914 45.7323 45.8613C46.7311 46.4084 47.8093 46.6819 48.9669 46.6819C50.1927 46.6819 51.3162 46.397 52.3377 45.8271C53.3819 45.2344 54.2104 44.4252 54.8232 43.3995C55.4361 42.3509 55.7425 41.177 55.7425 39.8777V24.1835C55.7425 23.5225 56.0603 23.1919 56.6959 23.1919H62.1777Z" 
      fill="currentColor"
    />
    <path 
      d="M113.591 23.1919C114.226 23.1919 114.544 23.5225 114.544 24.1835V51.9133C114.544 52.2096 114.453 52.449 114.272 52.6313C114.113 52.7909 113.874 52.8707 113.557 52.8707H109.198C108.676 52.8707 108.37 52.6541 108.279 52.221L107.7 49.1779C106.611 50.614 105.249 51.7423 103.615 52.563C102.003 53.3836 100.266 53.7939 98.4051 53.7939C95.9763 53.7939 93.8653 53.2468 92.0721 52.1526C90.2789 51.0585 88.9056 49.4971 87.9523 47.4683C86.9989 45.4396 86.5222 43.0575 86.5222 40.3222V24.2177C86.5222 23.8986 86.613 23.6592 86.7946 23.4997C86.9762 23.3173 87.2146 23.2261 87.5096 23.2261H92.9574C93.2752 23.2261 93.5135 23.3173 93.6724 23.4997C93.854 23.6592 93.9448 23.8986 93.9448 24.2177V40.3906C93.9448 41.5531 94.2285 42.613 94.796 43.5704C95.3862 44.5278 96.1693 45.2914 97.1453 45.8613C98.1441 46.4084 99.2223 46.6819 100.38 46.6819C101.606 46.6819 102.729 46.397 103.751 45.8271C104.795 45.2344 105.623 44.4252 106.236 43.3995C106.849 42.3509 107.156 41.177 107.156 39.8777V24.1835C107.156 23.5225 107.473 23.1919 108.109 23.1919H113.591Z" 
      fill="currentColor"
    />
    <path 
      d="M77.8148 2.90918C78.4369 2.90918 78.7479 3.20474 78.7479 3.79587V51.8815C78.7479 52.4954 78.4369 52.8023 77.8148 52.8023H72.4164C71.8166 52.8023 71.5167 52.4954 71.5167 51.8815V8.48739C71.5167 7.89626 71.2207 6.16796 72.4164 5.64508L77.8148 2.90918Z" 
      fill="currentColor"
    />
  </svg>
);

const HomeIcon = () => (
  <svg className="w-[18px] h-[18px]" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M6.29545 16.5C6.84774 16.5 7.29545 16.0523 7.29545 15.5V12.2059C7.29545 11.6536 7.74317 11.2059 8.29545 11.2059H9.56818C10.1205 11.2059 10.5682 11.6536 10.5682 12.2059V15.5C10.5682 16.0523 11.0159 16.5 11.5682 16.5H13.6591C14.2114 16.5 14.6591 16.0523 14.6591 15.5V9.44118V9.44118C15.553 9.44118 15.9938 8.35423 15.3523 7.73165L9.62829 2.17599C9.24032 1.79943 8.62331 1.79943 8.23534 2.17599L2.51133 7.73165C1.86988 8.35423 2.31064 9.44118 3.20455 9.44118V9.44118V15.5C3.20455 16.0523 3.65226 16.5 4.20455 16.5H6.29545Z" 
      stroke="currentColor" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

const TransferIcon = () => (
  <svg className="w-[18px] h-[18px]" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M12.5454 1.5L15.2727 4.22727M15.2727 4.22727L12.5454 6.95455M15.2727 4.22727L5.72727 4.2273C5.00395 4.2273 4.31026 4.51464 3.7988 5.0261C3.28734 5.53756 3 6.23125 3 6.95457V8.31821M5.72727 16.5L3 13.7727M3 13.7727L5.72727 11.0454M3 13.7727L12.5455 13.7727C13.2688 13.7727 13.9625 13.4854 14.4739 12.9739C14.9854 12.4625 15.2727 11.7688 15.2727 11.0455V9.68182" 
      stroke="currentColor" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

const HistoryIcon = () => (
  <svg className="w-[18px] h-[18px]" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" 
      stroke="currentColor" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M9 4.5V9L12 10.5" 
      stroke="currentColor" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

interface MenuItemProps {
  icon: React.ReactNode;
  label: string;
  href: string;
  isActive?: boolean;
}

const MenuItem: React.FC<MenuItemProps> = ({
  icon,
  label,
  href,
  isActive = false,
}) => {
  return (
    <Link
      href={href}
      className={`flex w-full h-10 px-4 items-center gap-2 transition-colors ${
        isActive 
          ? 'text-blue-600 bg-blue-50' 
          : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
      }`}
    >
      <div className="flex w-[190px] items-center gap-2 flex-shrink-0">
        <div className="flex items-start gap-2">
          <div className="flex w-[18px] h-[18px] justify-center items-center">
            {icon}
          </div>
        </div>
        <div className="font-lato text-base font-normal leading-5">
          {label}
        </div>
      </div>
    </Link>
  );
};

export const Sidebar: React.FC = () => {
  const pathname = usePathname();

  // Determine active states
  const isHomeActive = pathname === '/';
  const isTransferActive = pathname.startsWith('/transfer') || pathname.startsWith('/destinations') || pathname.startsWith('/summary') || pathname.startsWith('/payment');
  const isHistoryActive = pathname === '/history';

  return (
    <div className="flex w-[244px] h-screen pt-12 pb-4 flex-col justify-between items-start flex-shrink-0 rounded-r-lg bg-white shadow-[0_1px_2px_0_rgba(24,24,27,0.08)] fixed left-0 top-0 z-50">
      {/* Header */}
      <div className="flex flex-col items-start gap-12">
        {/* Logo */}
        <div className="flex px-4 flex-col items-start">
          <div className="text-gray-900">
            <ZuluLogo />
          </div>
        </div>

        {/* Menu */}
        <div className="flex flex-col items-start gap-6">
          {/* Home */}
          <MenuItem
            icon={<HomeIcon />}
            label="Home"
            href="/"
            isActive={isHomeActive}
          />

          {/* Transfer */}
          <MenuItem
            icon={<TransferIcon />}
            label="Transfer"
            href="/transfer"
            isActive={isTransferActive}
          />

          {/* Transaction History */}
          <MenuItem
            icon={<HistoryIcon />}
            label="Transaction History"
            href="/history"
            isActive={isHistoryActive}
          />
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
